import { AfterViewInit, Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { NumericDictionary } from 'lodash';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { DialogService } from 'src/app/services/dialog.service';
import { EntiService } from 'src/app/services/enti.service';
import { EventiSegnalazioniDataSource } from 'src/app/services/eventi-segnalazioni.datasource';
import { SegnalazioniService } from 'src/app/services/eventi-segnalazioni.service';
import { Toolbar, ToolbarEvent } from 'src/app/shared/components/toolbar/toolbar';
import { DettaglioDateComponent } from '../dettaglio-date/dettaglio-date.component';

@Component({
  selector: 'app-gestione-segnalazioni',
  templateUrl: './gestione-segnalazioni.component.html',
  styleUrls: ['./gestione-segnalazioni.component.css']
})
export class GestioneSegnalazioniComponent implements AfterViewInit {

  arrowFlag: boolean = false;
  risultatiPerPagina: number = 10;
  dataSource: EventiSegnalazioniDataSource;
  acl: string = '';

  segnalazioniSearchableDto: ModelEventiCalamitosi.EventiSearchableDto = {
    idEvento: null,
    dpgr: null,
    descrizione: null,
    attiAmmiComm: null,
    ocdpc: null,
    dataEventoDa: null,
    dataEventoA: null,
    primaDataChiusuraRaccolta: null,
    stato: null,
    inviato: null
  };

  public form: FormGroup;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('orderBy') orderBy: MatSelect;

  /**
   *
   *
   * @type {EventEmitter<ToolbarEvent>}
   * @memberof DataTableComponent
   */
  @Output()
  public onToolbarEvent: EventEmitter<ToolbarEvent> = new EventEmitter();

  public toolbar: Toolbar;

  /**
*
* Filtri di ricerca impostati dall'utente
* @type {ModelEventiCalamitosi.SegnalazioniSearchableDto}
*/
  public searchFilters: ModelEventiCalamitosi.EventiSearchableDto;
  openToggle: number = 0;
  emptyTableMessage: boolean;
  idTemplate: any;
  dataChiusuraRaccoltaDati: any;
  dataChiusuraCorrezioneDati: any;

  private buildForm(): void {
    let group = {
      idEvento: new FormControl(null, null),
      ocdpc: new FormControl(null, null),
      dpgr: new FormControl(null, null),
      dataEventoDa: new FormControl(null, null),
      dataEventoA: new FormControl(null, null),
      primaDataChiusuraRaccolta: new FormControl (null, null),
      descrizione: new FormControl(null, null),
      stato: new FormControl(null, null),
    }
    this.form = new FormGroup(group);
  }


  displayedColumns: string[] = ['dpgr', 'denominazione', 'stato', 'ocdpc', 'dataEvento', 'primaDataChiusuraRaccolta', 'inviato', 'actions'];
  // displayedColumnsPC: string[] = ['dpgr', 'denominazione', 'stato', 'ocdpc', 'dataEvento', 'inviato', 'actions'];

  constructor(
    private segnalazioniSvc: SegnalazioniService,
    private router: Router,
    private alertsCenterService: AlertsCenterService,
    private authenticationService: AuthenticationService,
    private dialogService: DialogService) {
    this.generateToolBar();

  }

  ngOnInit(): void {
    this.buildForm();
    this.dataSource = new EventiSegnalazioniDataSource(this.segnalazioniSvc);
    this.dataSource.errors$.subscribe(res => {
      if (res) this.alertsCenterService.showAlert({
        message: `Errore lettura dati`,
        type: 'danger',
        autoClosable: false
      });
    })

    this.acl = sessionStorage.getItem("acl");
    /*this.authenticationService.currentAcl.subscribe(res => {
      if (res !== null) {
        //this.acl = res;
        //this.dataSource.loadSegnalazioni('', this.segnalazioniSearchableDto, 'idEvento,ASC', 0, this.risultatiPerPagina, 1);
      }
    });*/
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.sort.direction = "desc";
      this.sort.active = "dataEvento";
      this.dataSource.loadSegnalazioni('', this.segnalazioniSearchableDto, 'dataEvento,'+this.sort.direction, 0, this.risultatiPerPagina, 1);
      // reset the paginator after sorting
      this.form.valueChanges.subscribe(() => this.paginator.pageIndex = 0);
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

      merge(this.sort.sortChange, this.paginator.page)
        .pipe(
          tap(() => {
            this.ricercaListaSegnalazioni();
          }))
        .subscribe();

      this.dataSource.counter$
        .pipe(
          tap((count) => {
            this.paginator.length = count;
          })
        )
        .subscribe();
    });
  }

  public ricercaListaSegnalazioni(resetPage?: boolean): void {

    if (this.form.controls.dataEventoA.value !== ""
      && this.form.controls.dataEventoA.value !== null
      && this.form.controls.dataEventoA.value !== undefined) {
      if (this.form.controls.dataEventoDa.value > this.form.controls.dataEventoA.value) {
        let message = "Data di inizio maggiore della data di fine"
        this.alertsCenterService.showAlert({
          message: message,
          type: 'danger',
          autoClosable: false
        });
        return
      }
    }

    this.searchFilters = {
      idEvento: this.form.controls['idEvento'].value !== "" ? this.form.controls['idEvento'].value : null,
      dpgr: this.form.controls['dpgr'].value !== "" ? this.form.controls['dpgr'].value : null,
      descrizione: this.form.controls['descrizione'].value !== "" ? this.form.controls['descrizione'].value : null,
      stato: this.form.controls['stato'].value !== "" ? this.form.controls['stato'].value : null,
      attiAmmiComm: null,
      ocdpc: this.form.controls['ocdpc'].value !== "" ? this.form.controls['ocdpc'].value : null,
      dataEventoDa: this.form.controls['dataEventoDa'].value !== "" ? this.form.controls['dataEventoDa'].value : null,
      dataEventoA: this.form.controls['dataEventoA'].value !== "" ? this.form.controls['dataEventoA'].value : null,
      primaDataChiusuraRaccolta: this.form.controls['primaDataChiusuraRaccolta'].value !== "" ? this.form.controls['primaDataChiusuraRaccolta'].value : null ? this.form.controls['primaDataChiusuraRaccolta'].value : undefined,
      inviato: null,
    }

    this.dataSource.loadSegnalazioni('', this.searchFilters, this.sort.active + "," + this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize, 1);

  }

  onNavigate(path) {
    this.router.navigate([path])
  }

  private generateToolBar() {
    this.toolbar = {
      toolbarCss: 'toolbar-vertical',
      actions: [
        {
          btnTitle: 'Segnalazioni',
          btnIconClass: 'article',
          btnActionEvent: 'compila_segnalazione',
          btnCssClass: 'btn btn-secondary'
        },
        {
          btnTitle: 'Dettaglio Date',
          btnIconClass: 'calendar_today',
          btnActionEvent: 'show_dialog_date',
          btnCssClass: 'btn btn-secondary'
        }
      ]
    }
  }

  openDettaglioDateDialog(idEvento: number) {
    //inserire qui la configurazione della material dialog MatDialogConfig per dati e css
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      idEvento: idEvento,
      predefiniti: false
    }

    const dialogRef = this.dialogService.openDialogSegnalazioni(idEvento).subscribe();
  }

  public ricercaDate(resetPage?: boolean): void {
    // this.dataSource.loadCampiWithCheck(this.controlList, this.searchFilters, "codiceCampo" + "," + "ASC", this.paginator.pageIndex, this.paginator.pageSize, 'N', this.templateDistribuito, this.allAbilitati);
  }

  public handleToolbarEvent(event: ToolbarEvent): void {
    if (event.event === 'compila_segnalazione') {
      this.onNavigate('lista-segnalazioni/' + event.data.idEvento)
    }
    if(event.event === 'show_dialog_date') {
      this.openDettaglioDateDialog(event.data.idEvento)
    }
  }

  showEnteTab(idEnte) {
    return "Ente prova " + idEnte;
  }

  onReset() {
    this.segnalazioniSearchableDto = {
      idEvento: null,
      dpgr: null,
      descrizione: null,
      attiAmmiComm: null,
      ocdpc: null,
      dataEventoDa: null,
      dataEventoA: null,
      primaDataChiusuraRaccolta: null,
      stato: null,
      inviato: null
    };
    this.form.reset();
    this.dataSource.loadSegnalazioni('', this.segnalazioniSearchableDto, 'dataEvento,ASC', 0, this.risultatiPerPagina, 1);
  }

 //rimane in ascolto: se il click non è fatto sull'icona chiude il menù
 @HostListener('document:click', ['$event'])
 documentClick(event) {
     if(event.srcElement.innerText !== 'more_horiz') this.openToggle = 0;
 }
}
